export class DealerDismantlerReasonModel {
  description: string;
  id: number;

  public static fromJson(itemBasicInfoJson: any): DealerDismantlerReasonModel {
    return Object.assign(new DealerDismantlerReasonModel(), itemBasicInfoJson);
  }
}
